export const loginFormStyles = (theme) => ({
  link: {
    margin: '0 0.1em',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
})
